import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f5d0efc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-content-between gap-2" }
const _hoisted_2 = { class: "p-input-icon-left float-right" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "button-container" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["onClick", "disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-text-secondary block mb-5" }, "Introduceti motiul pentru care respingeti cererea:", -1))
const _hoisted_15 = { class: "reason flex align-items-center gap-3 mb-3" }
const _hoisted_16 = { class: "flex justify-content-end gap-2 float-right" }

import { RegisterRequest } from '@/interfaces/RegisterRequest';
import { ref, PropType, toRaw, watch, computed } from 'vue';
import { useRouter } from 'vue-router';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import Tag from 'primevue/tag';
import Dialog from 'primevue/dialog';
import Textarea from 'primevue/textarea';
import RegisterRequestService from '@/services/RegisterRequestService';
import { DateUtils } from '@/utils/DateUtils';
import { useToast } from 'primevue/usetoast';
import { useListFilters } from '@/stores/listFilters';

const REMINDER_COOLDOWN_DAYS = 7;


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterRequestList',
  props: {
  requests: {
    type: Array as PropType<RegisterRequest[]>,
    default: () => []
  }
},
  setup(__props) {

const props = __props;

const router = useRouter();
const listFilters = useListFilters();

const filteredRequests = ref<RegisterRequest[]>([...props.requests]);
const rowsPerPage = ref(listFilters.rows);

const onPage = (event: any) => {
  listFilters.setRows(event.rows);
};

const searchQuery = ref(listFilters.registerRequestFilter);
const dialogVisible = ref(false);
const requestId = ref();
const requestReason = ref();

const safeDisplay = (value: string): string => value || '';

const clearFilter = () => {
  searchQuery.value = '';
  listFilters.clearRegisterRequestFilter();
  filteredRequests.value = [...props.requests];
};

const searchData = () => {
  const query = searchQuery.value?.toLowerCase() || '';
  listFilters.setRegisterRequestFilter(searchQuery.value ?? '');
  filteredRequests.value = props.requests.filter((wrapperPatient) => {
    const patient = toRaw(wrapperPatient);
    const firstName = (patient.firstName ?? '').trim();
    const lastName = (patient.lastName ?? '').trim();
    const fullName = `${firstName} ${lastName}`.toLowerCase();
    return (
      patient.phone?.toLowerCase().includes(query) ||
      fullName.includes(query) ||
      patient.email?.toLowerCase().includes(query) ||
      patient.specialty?.toLowerCase().includes(query)
    );
  });
};

const toast = useToast();
const reminderLoading = ref<string | null>(null);
const lastReminderAtOverrides = ref<Record<string, string>>({});

const lastReminderLabel = (data: RegisterRequest) => {
  const date = lastReminderAtOverrides.value[data.id] || data.lastReminderAt;
  return date ? `Ultima trimitere: ${DateUtils.format(date)}` : undefined;
};

const acceptRequest = (data) => {
  router.push({ name: 'doctors', query: { requestId: data.id } });
};

const declineRequest = (data) => {
  requestId.value = data.id;
  dialogVisible.value = true;
};

const sendReminder = async (data: RegisterRequest) => {
  const effectiveLastReminderAt = lastReminderAtOverrides.value[data.id] || data.lastReminderAt;
  if (effectiveLastReminderAt) {
    const daysSinceLast = DateUtils.daysBetween(effectiveLastReminderAt, new Date());
    if (daysSinceLast !== null && daysSinceLast < REMINDER_COOLDOWN_DAYS) {
      toast.add({
        severity: 'warn',
        summary: 'Atenție',
        detail: 'Invitația a mai fost trimisă în ultimele 7 zile',
        life: 4000
      });
      return;
    }
  }
  reminderLoading.value = data.id;
  try {
    const result = await RegisterRequestService.sendEnrollmentReminder(data.id);
    lastReminderAtOverrides.value[data.id] = result.lastReminderAt;
    toast.add({
      severity: 'success',
      summary: 'Succes',
      detail: 'Reminder-ul a fost trimis',
      life: 3000
    });
  } catch (e) {
    toast.add({
      severity: 'error',
      summary: 'Eroare',
      detail: 'Reminder-ul nu a putut fi trimis',
      life: 4000
    });
  } finally {
    reminderLoading.value = null;
  }
};

const performDeclineRequest = async () => {
  if (requestId.value) {
    const requestToSave: Partial<RegisterRequest> = {
      id: requestId.value,
      notes: requestReason.value
    };
    const response: RegisterRequest =
      await RegisterRequestService.rejectRegisterRequest(requestToSave);
    if (response.id) {
      location.reload();
    }
  }
};

watch(
  () => props.requests,
  (newValue) => {
    filteredRequests.value = [...newValue];
    searchData();
  },
  { immediate: true }
);

const computedRequests = computed(() => {
  return filteredRequests.value.map(r => ({
    ...r,
    sortName: `${r.firstName ?? ''} ${r.lastName ?? ''}`.toLowerCase(),
    sortSpecialty: (r.specialty ?? '').toLowerCase(),
    sortCreatedAt: r.createdAt ? new Date(r.createdAt).getTime() : 0
  }));
});


return (_ctx: any,_cache: any) => {
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IconField = _resolveComponent("IconField")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(DataTable), {
      value: computedRequests.value,
      onPage: onPage,
      selectionMode: "single",
      stripedRows: "",
      paginator: "",
      rows: rowsPerPage.value,
      sortField: "sortCreatedAt",
      sortOrder: -1,
      rowsPerPageOptions: [5, 10, 20, 50],
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport",
      currentPageReportTemplate: "{first} - {last} din {totalRecords}"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(Button), {
            type: "button",
            class: "p-button-sm",
            icon: "pi pi-filter-slash",
            outlined: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (clearFilter()))
          }),
          _createElementVNode("span", _hoisted_2, [
            _createVNode(_component_IconField, null, {
              default: _withCtx(() => [
                _createVNode(_component_InputIcon, { class: "pi pi-search" }),
                _createVNode(_component_InputText, {
                  class: "md:w-auto w-10rem",
                  onInput: searchData,
                  modelValue: searchQuery.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
                  placeholder: "Caută.."
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          field: "index",
          header: "#",
          sortable: false
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Nume",
          field: "sortName",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", null, _toDisplayString(safeDisplay(data.firstName) + ' ' + safeDisplay(data.lastName)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "phone",
          header: "Telefon"
        }),
        _createVNode(_unref(Column), {
          field: "email",
          header: "Email"
        }),
        _createVNode(_unref(Column), {
          field: "specialty",
          header: "Specializare",
          sortable: ""
        }),
        _createVNode(_unref(Column), {
          header: "Data cerere",
          field: "sortCreatedAt",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            (data.createdAt)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(DateUtils).formatWithTime(data.createdAt)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, " N/A "))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), { header: "Ultimul reminder" }, {
          body: _withCtx(({ data }) => [
            (data.reminderOptedOut)
              ? (_openBlock(), _createBlock(_unref(Tag), {
                  key: 0,
                  value: "Dezabonat",
                  severity: "warning"
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString((lastReminderAtOverrides.value[data.id] || data.lastReminderAt) ? _unref(DateUtils).format(lastReminderAtOverrides.value[data.id] || data.lastReminderAt) : '-'), 1))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), { header: "" }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: ($event: any) => (acceptRequest(data)),
                class: "button-accept",
                title: "Accepta cererea"
              }, _hoisted_9, 8, _hoisted_7),
              _createElementVNode("button", {
                onClick: ($event: any) => (declineRequest(data)),
                class: "button-decline",
                title: "Respinge cererea"
              }, _hoisted_12, 8, _hoisted_10),
              (!data.doctor && !data.reminderOptedOut)
                ? _withDirectives((_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: ($event: any) => (sendReminder(data)),
                    class: "button-reminder",
                    disabled: reminderLoading.value === data.id,
                    title: "Trimite reminder documente"
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(reminderLoading.value === data.id ? 'pi pi-spin pi-spinner' : 'pi pi-bell')
                    }, null, 2)
                  ], 8, _hoisted_13)), [
                    [
                      _directive_tooltip,
                      { value: lastReminderLabel(data), showDelay: 100 },
                      void 0,
                      { top: true }
                    ]
                  ])
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "rows"]),
    _createVNode(_unref(Dialog), {
      visible: dialogVisible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((dialogVisible).value = $event)),
      modal: "",
      header: "Respingere cerere",
      style: { width: '25rem' }
    }, {
      default: _withCtx(() => [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_unref(Textarea), {
            modelValue: requestReason.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((requestReason).value = $event)),
            rows: "5",
            cols: "37"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_unref(Button), {
            type: "button",
            label: "Salveaza",
            onClick: performDeclineRequest
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})